module.exports = __webpack_public_path__ + "static/media/bottom4.154a4628.png";